import React, { FC } from 'react'

import { IconDiagnosticsProps } from './IconDiagnostics.types'
import * as Styled from './styles/IconDiagnostics.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDiagnostics: FC<IconDiagnosticsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDiagnosticsProps['size'],
  isResponsive = false,
}: IconDiagnosticsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M15 29.025v6.5a7.5 7.5 0 1 0 15 0v-15.5a5 5 0 0 1 10 0v8'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M19.56 5.605c3.583.592 5.975 3.802 5.345 7.168l-1.807 8.314c-.925 4.625-4.408 7.938-8.098 7.938-3.69 0-7.16-3.313-8.087-7.938l-1.815-8.314c-.633-3.366 1.75-6.576 5.342-7.168'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M40 28.032h3v3a3 3 0 1 1-3-3Z' stroke='#EA1A1A' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M12.515 4.975h-1.52a.49.49 0 0 0-.49.49v.02c0 .27.22.49.49.49h1.52c.27 0 .49-.22.49-.49v-.02a.49.49 0 0 0-.49-.49Zm6.493 0h-1.52a.49.49 0 0 0-.49.49v.02c0 .27.219.49.49.49h1.52c.27 0 .49-.22.49-.49v-.02a.49.49 0 0 0-.49-.49Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDiagnostics
